import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { UnionServiceDelegation } from "../../Model/UnionServiceDelegation/UnionServiceDelegation";

export async function patchUnionDelegationServiceService(id, data) {
    let response = await getAPIResponse("/v1/union-service-delegation/" + id, data, "PATCH");
    if (response === null) {
        return null;
    }
    return UnionServiceDelegation.createFromResponseData(response);
}